<template>
  <div>
    <!--Charts-->
    <div class="row">
      <RecibosDePoliza :poliza="$route.params.id"></RecibosDePoliza>
    </div>
  </div>
</template>
<script>
import {RecibosDePoliza} from "@/components";

export default {
  components: {
    RecibosDePoliza
  },
  data() {
    return {};
  }
};
</script>
<style>
</style>
